export default "__VITE_ASSET__CpAT9Hkf__"